// import React, { useEffect, useState } from 'react'
// import {
//   Table,
//   Input,
//   Button,
//   Modal,
//   Form,
//   Row,
//   Col,
//   DatePicker,
//   Select,
//   Upload,
// } from 'antd'
// import {
//   PlusOutlined,
//   EditOutlined,
//   DeleteOutlined,
//   CrownOutlined,
//   UploadOutlined,
// } from '@ant-design/icons'
// import axiosInstance from '../../Utils/axiosInstance'
// import {
//   CreateLifeTimeMemberData,
//   GetLifeTimeMemberData,
//   UpdateLifeTimeMemberData,
//   DeleteLifeTimeMemberData,
// } from "../../API's/AdminApi"
// import { toast } from 'react-toastify'
// import dayjs from 'dayjs'
// import { ImgPath } from "../../API's/UserApi"

// const { Option } = Select

// export default function LifeTimeMembershipMaster() {
//   const [data, setData] = useState([])
//   const [searchText, setSearchText] = useState('')
//   const [showForm, setShowForm] = useState(false)
//   const [editData, setEditData] = useState(null)
//   const [deleteId, setDeleteId] = useState(null)

//   const [tableLoading, setTableLoading] = useState(false)
//   const [submitLoading, setSubmitLoading] = useState(false)
//   const [deleteLoading, setDeleteLoading] = useState(false)

//   const [fileList, setFileList] = useState([])
//   const [previewImage, setPreviewImage] = useState('')
//   const [pagination, setPagination] = useState({
//     current: 1,
//     pageSize: 5,
//   })

//   const [form] = Form.useForm()

//   // ---------------- GET DATA ----------------
//   const getMembers = async () => {
//     try {
//       setTableLoading(true)
//       const res = await axiosInstance.get(GetLifeTimeMemberData)
//       setData(res.data || [])
//     } catch (error) {
//       toast.error('Failed to load members')
//     } finally {
//       setTableLoading(false)
//     }
//   }

//   useEffect(() => {
//     getMembers()
//   }, [])

//   // ---------------- RESET ----------------
//   const resetFormState = () => {
//     form.resetFields()
//     setFileList([])
//     setPreviewImage('')
//     setEditData(null)
//     setShowForm(false)
//   }

//   // ---------------- ADD / UPDATE ----------------
//   const onFinish = async (values) => {
//     try {
//       setSubmitLoading(true)

//       const formData = new FormData()

//       formData.append('name', values.name || '')
//       formData.append('gender', values.gender || '')
//       formData.append('aadhaarNo', values.aadhaarNo || '')
//       formData.append('mobileNo', values.mobileNo || '')
//       formData.append('emergencyMobNo', values.emergencyMobNo || '')
//       formData.append('emergencyName', values.emergencyName || '')
//       formData.append('emergencyRelation', values.emergencyRelation || '')
//       formData.append('address', values.address || '')

//       formData.append(
//         'birthDate',
//         values.birthDate ? values.birthDate.format('YYYY-MM-DD') : '',
//       )

//       formData.append(
//         'joiningDate',
//         values.joiningDate ? values.joiningDate.format('YYYY-MM-DD') : '',
//       )

//       formData.append(
//         'validUpToDate',
//         values.validUpToDate ? values.validUpToDate.format('YYYY-MM-DD') : '',
//       )

//       // FILE handling
//       if (fileList.length > 0 && fileList[0].originFileObj) {
//         // new uploaded file
//         formData.append('photo', fileList[0].originFileObj)
//       }

//       let res

//       if (editData) {
//         formData.append('id', editData.id)

//         res = await axiosInstance.put(UpdateLifeTimeMemberData, formData, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//         })

//         if (res.data === 'UPDATED') {
//           toast.success('Member updated successfully')
//         }
//       } else {
//         res = await axiosInstance.post(CreateLifeTimeMemberData, formData, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//         })

//         if (res.data === 'SAVED') {
//           toast.success('Member created successfully')
//         }

//         if (res.data === 'ALREADYEXISTS') {
//           toast.warn('Employee mobile no. already exist')
//           return
//         }
//       }

//       resetFormState()
//       getMembers()
//     } catch (error) {
//       toast.error(error?.response?.data?.message || 'Something went wrong')
//     } finally {
//       setSubmitLoading(false)
//     }
//   }

//   // ---------------- EDIT ----------------
//   const handleEdit = (record) => {
//     setEditData(record)
//     setShowForm(true)

//     const imageUrl = record.photo ? `${ImgPath}${record.photo}` : ''
//     const files = record.photo
//       ? [
//           {
//             uid: '-1',
//             name: record.photo,
//             status: 'done',
//             url: imageUrl,
//           },
//         ]
//       : []

//     setFileList(files)
//     setPreviewImage(imageUrl)

//     form.setFieldsValue({
//       ...record,
//       birthDate: record.birthDate ? dayjs(record.birthDate) : null,
//       joiningDate: record.joiningDate ? dayjs(record.joiningDate) : null,
//       validUpToDate: record.validUpToDate ? dayjs(record.validUpToDate) : null,
//       file: files,
//     })
//   }

//   // ---------------- DELETE ----------------
//   const confirmDelete = async () => {
//     try {
//       setDeleteLoading(true)

//       const res = await axiosInstance.delete(
//         `${DeleteLifeTimeMemberData}?id=${deleteId}`,
//       )

//       if (res.data) {
//         toast.success(res.data.message || 'Deleted successfully')
//         setDeleteId(null)
//         getMembers()
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || 'Delete failed')
//     } finally {
//       setDeleteLoading(false)
//     }
//   }

//   // ---------------- TABLE ----------------
//   const columns = [
//     {
//       title: 'Sr No',
//       render: (_, __, index) => index + 1,
//     },
//     {
//       title: 'Name',
//       dataIndex: 'name',
//     },
//     {
//       title: 'Mobile',
//       dataIndex: 'mobileNo',
//     },
//     {
//       title: 'Gender',
//       dataIndex: 'gender',
//       render: (value) => {
//         if (value === 1) return 'Male'
//         if (value === 2) return 'Female'
//         return '-'
//       },
//     },
//     {
//       title: 'Action',
//       render: (_, record) => (
//         <>
//           <Button
//             icon={<EditOutlined />}
//             onClick={() => handleEdit(record)}
//             style={{ marginRight: 8 }}
//           />
//           <Button
//             danger
//             icon={<DeleteOutlined />}
//             onClick={() => setDeleteId(record.id)}
//           />
//         </>
//       ),
//     },
//   ]

//   // ---------------- SEARCH ----------------
//   const filteredData = data.filter((item) =>
//     item.name?.toLowerCase().includes(searchText.toLowerCase()),
//   )

//   return (
//     <div>
//       {/* TABLE */}
//       {!showForm && (
//         <div className="page-background p-2 p-md-4">
//           <div className="page-header">
//             <h2>
//               <CrownOutlined style={{ marginRight: 8 }} />
//               Life Time Membership Master
//             </h2>
//           </div>

//           <Row gutter={16} className="pb-2 m-0">
//             <Col xs={24} md={6} xl={14}></Col>
//             <Col xs={24} md={12} xl={6} className="pt-2 pt-md-0">
//               <Input
//                 placeholder="Search here"
//                 onChange={(e) => setSearchText(e.target.value)}
//               />
//             </Col>

//             <Col xs={24} md={6} xl={4} className="pt-2 pt-md-0 mt-1">
//               <button
//                 className="btn-aqua"
//                 onClick={() => {
//                   resetFormState()
//                   setShowForm(true)
//                 }}
//               >
//                 <PlusOutlined /> Add Member
//               </button>
//             </Col>
//           </Row>

//           <Table
//             className="custom-table-header shadow"
//             columns={columns}
//             dataSource={filteredData}
//             rowKey="id"
//             loading={tableLoading}
//             bordered
//             style={{ overflowX: 'auto', backgroundColor: 'white' }}
//             pagination={{
//               showSizeChanger: true, // enable page size dropdown
//               pageSizeOptions: ['5', '10', '20', '50'],
//               showTotal: (total, range) =>
//                 `${range[0]}-${range[1]} of ${total} items`,
//             }}
//           />
//         </div>
//       )}

//       {/* FORM */}
//       {showForm && (
//         <div className="row p-0 m-0">
//           <div className="col-12 col-lg-1"></div>

//           <div className="col-12 col-lg-10 page-background1 p-2 p-md-4">
//             <div className="page-header">
//               <h2>
//                 <CrownOutlined style={{ marginRight: 8 }} />
//                 Life Time Membership Master
//               </h2>
//             </div>

//             <Form form={form} layout="vertical" onFinish={onFinish}>
//               <Row gutter={16}>
//                 {/* LEFT SIDE */}
//                 <Col xs={24} md={16}>
//                   <Row gutter={16}>
//                     <Col xs={24}>
//                       <Form.Item
//                         name="name"
//                         label="Name"
//                         rules={[{ required: true }]}
//                       >
//                         <Input />
//                       </Form.Item>
//                     </Col>

//                     <Col xs={24} md={12}>
//                       <Form.Item name="gender" label="Gender">
//                         <Select>
//                           <Option value={1}>Male</Option>
//                           <Option value={2}>Female</Option>
//                         </Select>
//                       </Form.Item>
//                     </Col>

//                     <Col xs={24} md={12}>
//                       <Form.Item
//                         name="aadhaarNo"
//                         label="Aadhar No"
//                         rules={[
//                           { required: true, message: 'Enter mobile number' },
//                           {
//                             pattern: /^[0-9]{12}$/,
//                             message: 'Aadhar must be 12 digits',
//                           },
//                         ]}
//                       >
//                         <Input maxLength={12} />
//                       </Form.Item>
//                     </Col>

//                     <Col xs={24} md={12}>
//                       <Form.Item
//                         name="mobileNo"
//                         label="Mobile No"
//                         rules={[
//                           { required: true, message: 'Enter mobile number' },
//                           {
//                             pattern: /^[0-9]{10}$/,
//                             message: 'Mobile must be 10 digits',
//                           },
//                         ]}
//                       >
//                         <Input
//                           maxLength={10}
//                           onChange={(e) => {
//                             const value = e.target.value.replace(/[^0-9]/g, '')
//                             e.target.value = value
//                           }}
//                         />
//                       </Form.Item>
//                     </Col>

//                     <Col xs={24} md={12}>
//                       <Form.Item
//                         name="emergencyMobNo"
//                         label="Emergency Mobile No"
//                         rules={[
//                           { required: true, message: 'Enter mobile number' },
//                           {
//                             pattern: /^[0-9]{10}$/,
//                             message: 'Mobile must be 10 digits',
//                           },
//                         ]}
//                       >
//                         <Input
//                           maxLength={10}
//                           onChange={(e) => {
//                             const value = e.target.value.replace(/[^0-9]/g, '')
//                             e.target.value = value
//                           }}
//                         />
//                       </Form.Item>
//                     </Col>

//                     <Col xs={24} md={12}>
//                       <Form.Item
//                         name="emergencyName"
//                         label="Emergency Name"
//                         rules={[{ required: true }]}
//                       >
//                         <Input />
//                       </Form.Item>
//                     </Col>

//                     <Col xs={24} md={12}>
//                       <Form.Item
//                         name="emergencyRelation"
//                         label="Emergency Relation"
//                         rules={[{ required: true }]}
//                       >
//                         <Input />
//                       </Form.Item>
//                     </Col>

//                     <Col xs={24} md={8}>
//                       <Form.Item name="birthDate" label="Birth Date">
//                         <DatePicker
//                           size="large"
//                           style={{ width: '100%' }}
//                           format="DD-MM-YYYY"
//                         />
//                       </Form.Item>
//                     </Col>

//                     <Col xs={24} md={8}>
//                       <Form.Item name="joiningDate" label="Joining Date">
//                         <DatePicker
//                           size="large"
//                           style={{ width: '100%' }}
//                           format="DD-MM-YYYY"
//                         />
//                       </Form.Item>
//                     </Col>

//                     <Col xs={24} md={8}>
//                       <Form.Item name="validUpToDate" label="Valid Upto Date">
//                         <DatePicker
//                           size="large"
//                           style={{ width: '100%' }}
//                           format="DD-MM-YYYY"
//                         />
//                       </Form.Item>
//                     </Col>

//                     <Col xs={24}>
//                       <Form.Item
//                         name="address"
//                         label="Address"
//                         rules={[{ required: true }]}
//                       >
//                         <Input />
//                       </Form.Item>
//                     </Col>
//                   </Row>
//                 </Col>

//                 {/* RIGHT SIDE */}
//                 <Col xs={24} md={8}>
//                   <Form.Item
//                     name="file"
//                     label="Upload Photo"
//                     rules={[{ required: !editData }]}
//                   >
//                     <Upload
//                       fileList={fileList}
//                       onChange={({ fileList }) => {
//                         setFileList(fileList)

//                         if (fileList.length > 0) {
//                           const fileObj = fileList[0]

//                           // NEW IMAGE
//                           if (fileObj.originFileObj) {
//                             const reader = new FileReader()

//                             reader.readAsDataURL(fileObj.originFileObj)

//                             reader.onload = () => {
//                               setPreviewImage(reader.result)
//                             }
//                           }

//                           // EXISTING IMAGE
//                           else if (fileObj.url) {
//                             setPreviewImage(fileObj.url)
//                           }
//                         } else {
//                           setPreviewImage('')
//                         }

//                         form.setFieldsValue({ file: fileList })
//                       }}
//                       beforeUpload={() => false}
//                       onRemove={() => {
//                         setFileList([])
//                         setPreviewImage('')
//                         form.setFieldsValue({ file: [] })
//                       }}
//                       maxCount={1}
//                       listType="picture"
//                     >
//                       <Button icon={<UploadOutlined />}>Select Photo</Button>
//                     </Upload>

//                     {previewImage && (
//                       <img
//                         src={previewImage}
//                         alt="Preview"
//                         style={{
//                           width: '100%',
//                           maxHeight: 300,
//                           objectFit: 'cover',
//                           marginTop: 10,
//                           borderRadius: 8,
//                           border: '1px solid #ddd',
//                         }}
//                       />
//                     )}
//                   </Form.Item>
//                 </Col>
//               </Row>

//               <Form.Item>
//                 <Button
//                   type="primary"
//                   htmlType="submit"
//                   loading={submitLoading}
//                 >
//                   {editData ? 'Update' : 'Submit'}
//                 </Button>

//                 <Button style={{ marginLeft: 10 }} onClick={resetFormState}>
//                   Cancel
//                 </Button>
//               </Form.Item>
//             </Form>
//           </div>

//           <div className="col-12 col-lg-1"></div>
//         </div>
//       )}

//       {/* DELETE */}
//       <Modal
//         title="Confirm Delete"
//         open={deleteId !== null}
//         onOk={confirmDelete}
//         confirmLoading={deleteLoading}
//         onCancel={() => setDeleteId(null)}
//       >
//         Are you sure you want to delete this member?
//       </Modal>
//     </div>
//   )
// }

import React, { useEffect, useState } from 'react'
import {
  Table,
  Input,
  Button,
  Modal,
  Form,
  Row,
  Col,
  DatePicker,
  Select,
  Upload,
} from 'antd'
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  CrownOutlined,
  UploadOutlined,
  PrinterOutlined,
} from '@ant-design/icons'
import axiosInstance from '../../Utils/axiosInstance'
import {
  CreateLifeTimeMemberData,
  GetLifeTimeMemberData,
  UpdateLifeTimeMemberData,
  DeleteLifeTimeMemberData,
  AvailableSlotData,
  GetMembershipFeeData,
  GetLifeTimeMemberCard,
} from "../../API's/AdminApi"
import { toast } from 'react-toastify'
import dayjs from 'dayjs'
import { ImgPath, PdfPath } from "../../API's/UserApi"

const { Option } = Select

export default function LifeTimeMembershipMaster() {
  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [showForm, setShowForm] = useState(false)
  const [editData, setEditData] = useState(null)
  const [deleteId, setDeleteId] = useState(null)

  const [tableLoading, setTableLoading] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)

  const [feeAmount, setFeeAmount] = useState(0)
  const [feeLoading, setFeeLoading] = useState(false)
  const [slotList, setSlotList] = useState([])
  const [slotLoading, setSlotLoading] = useState(false)

  const [fileList, setFileList] = useState([])
  const [previewImage, setPreviewImage] = useState('')
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
  })

  const [form] = Form.useForm()

  // ---------------- GET DATA ----------------
  const getMembers = async () => {
    try {
      setTableLoading(true)
      const res = await axiosInstance.get(GetLifeTimeMemberData)
      setData(res.data || [])
    } catch (error) {
      toast.error('Failed to load members')
    } finally {
      setTableLoading(false)
    }
  }

  const getSlots = async () => {
    try {
      setSlotLoading(true)

      const res = await axiosInstance.get(AvailableSlotData)

      setSlotList(res.data || [])
    } catch (error) {
      toast.error('Failed to load slots')
    } finally {
      setSlotLoading(false)
    }
  }

  useEffect(() => {
    getMembers()
    getSlots()
  }, [])

  // ===================

  const handlePrintCard = async (userId) => {
    try {
      const res = await axiosInstance.get(
        `${GetLifeTimeMemberCard}?userId=${userId}`,
      )

      const pdfFileName = res.data

      if (pdfFileName) {
        window.open(`${PdfPath}${pdfFileName}`, '_blank')
      } else {
        toast.error('PDF file not found')
      }
    } catch (error) {
      toast.error('Failed to print card')
    }
  }

  // ---------------- RESET ----------------
  const resetFormState = () => {
    form.resetFields()
    setFileList([])
    setPreviewImage('')
    setEditData(null)
    setShowForm(false)
  }

  // =====================================

  const getFeeByBirthDate = async (date) => {
    try {
      setFeeLoading(true)

      const formattedDate = dayjs(date).format('YYYY-MM-DD')

      const res = await axiosInstance.get(
        `${GetMembershipFeeData}?userType=4&birthDate=${formattedDate}`,
      )

      // userType == 4 for Lifetime Members }

      setFeeAmount(res.data || 0)

      // set in form also
      form.setFieldsValue({
        amount: res.data.amount || 0,
      })
    } catch (error) {
      toast.error('Failed to get fee amount')
    } finally {
      setFeeLoading(false)
    }
  }

  // ---------------- ADD / UPDATE ----------------
  const onFinish = async (values) => {
    try {
      setSubmitLoading(true)

      const formData = new FormData()

      formData.append('name', values.name || '')
      formData.append('gender', values.gender || '')
      formData.append('aadhaarNo', values.aadhaarNo || '')
      formData.append('mobileNo', values.mobileNo || '')
      formData.append('emergencyMobNo', values.emergencyMobNo || '')
      formData.append('emergencyName', values.emergencyName || '')
      formData.append('emergencyRelation', values.emergencyRelation || '')
      formData.append('slotId', values.slotId || '')
      formData.append('amount', feeAmount || 0)
      formData.append('address', values.address || '')

      formData.append(
        'birthDate',
        values.birthDate ? values.birthDate.format('YYYY-MM-DD') : '',
      )

      formData.append(
        'joiningDate',
        values.joiningDate ? values.joiningDate.format('YYYY-MM-DD') : '',
      )

      formData.append(
        'validUpToDate',
        values.validUpToDate ? values.validUpToDate.format('YYYY-MM-DD') : '',
      )

      // FILE handling
      if (fileList.length > 0 && fileList[0].originFileObj) {
        // new uploaded file
        formData.append('photo', fileList[0].originFileObj)
      }

      let res

      if (editData) {
        formData.append('id', editData.id)

        res = await axiosInstance.put(UpdateLifeTimeMemberData, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        if (res.data === 'UPDATED') {
          toast.success('Member updated successfully')
        }
      } else {
        res = await axiosInstance.post(CreateLifeTimeMemberData, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        if (res.data === 'SAVED') {
          toast.success('Member created successfully')
        }

        if (res.data === 'ALREADYEXISTS') {
          toast.warn('Employee mobile no. already exist')
          return
        }
      }

      resetFormState()
      getMembers()
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Something went wrong')
    } finally {
      setSubmitLoading(false)
    }
  }

  // ---------------- EDIT ----------------
  const handleEdit = (record) => {
    setEditData(record)
    setShowForm(true)

    setFeeAmount(record.amount || 0)
    const imageUrl = record.photoName ? `${ImgPath}${record.photoName}` : ''
    const files = record.photoName
      ? [
          {
            uid: '-1',
            name: record.photoName,
            status: 'done',
            url: imageUrl,
          },
        ]
      : []

    setFileList(files)
    setPreviewImage(imageUrl)

    form.setFieldsValue({
      ...record,
      birthDate: record.birthDate ? dayjs(record.birthDate) : null,
      joiningDate: record.joiningDate ? dayjs(record.joiningDate) : null,
      validUpToDate: record.validUpToDate ? dayjs(record.validUpToDate) : null,
      file: files,
    })
  }

  // ---------------- DELETE ----------------
  const confirmDelete = async () => {
    try {
      setDeleteLoading(true)

      const res = await axiosInstance.delete(
        `${DeleteLifeTimeMemberData}?id=${deleteId}`,
      )

      if (res.data) {
        toast.success(res.data.message || 'Deleted successfully')
        setDeleteId(null)
        getMembers()
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Delete failed')
    } finally {
      setDeleteLoading(false)
    }
  }

  // ---------------- TABLE ----------------
  const columns = [
    {
      title: 'Sr No',
      render: (_, __, index) => index + 1,
    },
    {
      title: 'Name',
      dataIndex: 'name',
    },
    {
      title: 'Mobile',
      dataIndex: 'mobileNo',
    },
    {
      title: 'Gender',
      dataIndex: 'gender',
      render: (value) => {
        if (value === 1) return 'Male'
        if (value === 2) return 'Female'
        return '-'
      },
    },
    {
      title: 'Slot',
      dataIndex: 'slotId',
      render: (slotId) => {
        const slot = slotList.find((item) => item.id === slotId)

        return slot ? `${slot.timeFrom} To ${slot.timeTo}` : '-'
      },
    },
    {
      title: 'Action',
      render: (_, record) => (
        <>
          <Button
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
            style={{ marginRight: 8 }}
          />
          <Button
            danger
            icon={<DeleteOutlined />}
            onClick={() => setDeleteId(record.id)}
            style={{ marginRight: 8 }}
          />

          <Button
            type="primary"
            icon={<PrinterOutlined />}
            onClick={() => handlePrintCard(record.id)}
            className='mt-2 mt-lg-0'
          >
            Print Card
          </Button>
        </>
      ),
    },
  ]

  // ---------------- SEARCH ----------------
  const filteredData = data.filter((item) =>
    item.name?.toLowerCase().includes(searchText.toLowerCase()),
  )

  return (
    <div>
      {/* TABLE */}
      {!showForm && (
        <div className="page-background p-2 p-md-4">
          <div className="page-header">
            <h2>
              <CrownOutlined style={{ marginRight: 8 }} />
              Life Time Membership Master
            </h2>
          </div>

          <Row gutter={16} className="pb-2 m-0">
            <Col xs={24} md={6} xl={14}></Col>
            <Col xs={24} md={12} xl={6} className="pt-2 pt-md-0">
              <Input
                placeholder="Search here"
                onChange={(e) => setSearchText(e.target.value)}
              />
            </Col>

            <Col xs={24} md={6} xl={4} className="pt-2 pt-md-0 mt-1">
              <button
                className="btn-aqua"
                onClick={() => {
                  resetFormState()
                  setShowForm(true)
                }}
              >
                <PlusOutlined /> Add Member
              </button>
            </Col>
          </Row>

          <Table
            className="custom-table-header shadow"
            columns={columns}
            dataSource={filteredData}
            rowKey="id"
            loading={tableLoading}
            bordered
            style={{ overflowX: 'auto', backgroundColor: 'white' }}
            pagination={{
              showSizeChanger: true, // enable page size dropdown
              pageSizeOptions: ['5', '10', '20', '50'],
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
            }}
          />
        </div>
      )}

      {/* FORM */}
      {showForm && (
        <div className="row p-0 m-0">
          <div className="col-12 col-lg-1"></div>

          <div className="col-12 col-lg-10 page-background1 p-2 p-md-4">
            <div className="page-header">
              <h2>
                <CrownOutlined style={{ marginRight: 8 }} />
                Life Time Membership Master
              </h2>
            </div>

            <Form form={form} layout="vertical" onFinish={onFinish}>
              <Row gutter={16}>
                {/* LEFT SIDE */}
                <Col xs={24} md={16}>
                  <Row gutter={16}>
                    <Col xs={24}>
                      <Form.Item
                        name="name"
                        label="Name"
                        rules={[{ required: true }]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item name="gender" label="Gender">
                        <Select>
                          <Option value={1}>Male</Option>
                          <Option value={2}>Female</Option>
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        name="aadhaarNo"
                        label="Aadhar No"
                        rules={[
                          { required: true, message: 'Enter mobile number' },
                          {
                            pattern: /^[0-9]{12}$/,
                            message: 'Aadhar must be 12 digits',
                          },
                        ]}
                      >
                        <Input maxLength={12} />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        name="mobileNo"
                        label="Mobile No"
                        rules={[
                          { required: true, message: 'Enter mobile number' },
                          {
                            pattern: /^[0-9]{10}$/,
                            message: 'Mobile must be 10 digits',
                          },
                        ]}
                      >
                        <Input
                          maxLength={10}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9]/g, '')
                            e.target.value = value
                          }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        name="emergencyMobNo"
                        label="Emergency Mobile No"
                        rules={[
                          { required: true, message: 'Enter mobile number' },
                          {
                            pattern: /^[0-9]{10}$/,
                            message: 'Mobile must be 10 digits',
                          },
                        ]}
                      >
                        <Input
                          maxLength={10}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9]/g, '')
                            e.target.value = value
                          }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        name="emergencyName"
                        label="Emergency Name"
                        rules={[{ required: true }]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        name="emergencyRelation"
                        label="Emergency Relation"
                        rules={[{ required: true }]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={8}>
                      <Form.Item
                        name="birthDate"
                        label="Birth Date"
                        rules={[{ required: true }]}
                      >
                        <DatePicker
                          size="large"
                          style={{ width: '100%' }}
                          format="DD-MM-YYYY"
                          onChange={(date) => {
                            if (date) {
                              getFeeByBirthDate(date)
                            } else {
                              setFeeAmount(0)

                              form.setFieldsValue({
                                amount: 0,
                              })
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={8}>
                      <Form.Item
                        name="joiningDate"
                        label="Joining Date"
                        rules={[{ required: true }]}
                      >
                        <DatePicker
                          size="large"
                          style={{ width: '100%' }}
                          format="DD-MM-YYYY"
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={8}>
                      <Form.Item
                        name="validUpToDate"
                        label="Valid Upto Date"
                        rules={[{ required: true }]}
                      >
                        <DatePicker
                          size="large"
                          style={{ width: '100%' }}
                          format="DD-MM-YYYY"
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={16}>
                      <Form.Item
                        name="slotId"
                        label="Select Slot"
                        rules={[
                          { required: true, message: 'Please select slot' },
                        ]}
                      >
                        <Select
                          placeholder="Select Slot"
                          loading={slotLoading}
                          allowClear
                        >
                          {slotList.map((item) => (
                            <Option key={item.id} value={item.id}>
                              Time From - {item.timeFrom} To - {item.timeTo}{' '}
                              <br />
                              <span style={{ fontSize: '11px', color: 'gray' }}>
                                {' '}
                                (Gender -{' '}
                                {item.gender === 1
                                  ? 'Male Only'
                                  : item.gender === 2
                                  ? 'Female Only'
                                  : item.gender === 3
                                  ? 'Male & Female'
                                  : '-'}{' '}
                                )
                              </span>
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24}>
                      <Form.Item
                        name="address"
                        label="Address"
                        rules={[{ required: true }]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                {/* RIGHT SIDE */}
                <Col xs={24} md={8}>
                  <Form.Item
                    name="file"
                    label="Upload Photo"
                    rules={[{ required: !editData }]}
                  >
                    <Upload
                      fileList={fileList}
                      onChange={({ fileList }) => {
                        setFileList(fileList)

                        if (fileList.length > 0) {
                          const fileObj = fileList[0]

                          // NEW IMAGE
                          if (fileObj.originFileObj) {
                            const reader = new FileReader()

                            reader.readAsDataURL(fileObj.originFileObj)

                            reader.onload = () => {
                              setPreviewImage(reader.result)
                            }
                          }

                          // EXISTING IMAGE
                          else if (fileObj.url) {
                            setPreviewImage(fileObj.url)
                          }
                        } else {
                          setPreviewImage('')
                        }

                        form.setFieldsValue({ file: fileList })
                      }}
                      beforeUpload={() => false}
                      onRemove={() => {
                        setFileList([])
                        setPreviewImage('')
                        form.setFieldsValue({ file: [] })
                      }}
                      maxCount={1}
                      listType="picture"
                    >
                      <Button icon={<UploadOutlined />}>Select Photo</Button>
                    </Upload>

                    {previewImage && (
                      <img
                        src={previewImage}
                        alt="Preview"
                        style={{
                          width: '100%',
                          maxHeight: 300,
                          objectFit: 'cover',
                          marginTop: 10,
                          borderRadius: 8,
                          border: '1px solid #ddd',
                        }}
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={submitLoading}
                >
                  {editData ? 'Update' : 'Submit'}
                </Button>

                <Button style={{ marginLeft: 10 }} onClick={resetFormState}>
                  Cancel
                </Button>
              </Form.Item>
            </Form>
          </div>

          <div className="col-12 col-lg-1"></div>
        </div>
      )}

      {/* DELETE */}
      <Modal
        title="Confirm Delete"
        open={deleteId !== null}
        onOk={confirmDelete}
        confirmLoading={deleteLoading}
        onCancel={() => setDeleteId(null)}
      >
        Are you sure you want to delete this member?
      </Modal>
    </div>
  )
}
